"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Thu Aug 02 2018
 */

var typescript_ioc_1 = require("@logio/typescript-ioc");

var Settings_1 = require("../model/Settings");

var ConstraintSettingsConverter_1 = require("./constraint/ConstraintSettingsConverter");

var OptimizationGoalsSettingsConverter_1 = require("./optimalization-goal/OptimizationGoalsSettingsConverter");

var SettingsConverter_1 = require("./SettingsConverter");

var StrategySettingsConverter_1 = require("./strategy/StrategySettingsConverter");
/**
 * Default implementation of SettingsConverter.
 *
 * @author RV
 */


var SettingsConverterImpl =
/*#__PURE__*/
function (_SettingsConverter_1$) {
  _inherits(SettingsConverterImpl, _SettingsConverter_1$);

  function SettingsConverterImpl(optGoalsSettingsConverter, strategySettingsConverter, constraintSettingsConverter) {
    var _this;

    _classCallCheck(this, SettingsConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SettingsConverterImpl).call(this));
    _this.optGoalsSettingsConverter = optGoalsSettingsConverter;
    _this.strategySettingsConverter = strategySettingsConverter;
    _this.constraintSettingsConverter = constraintSettingsConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(SettingsConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      return new Settings_1.Settings(Settings_1.Settings.schema.id.valueOf(conversions.documentToClassId(source)), Settings_1.Settings.schema.title.valueOf(source.title), Settings_1.Settings.schema.priceZoneId.valueOf(conversions.asObject(source, 'priceZoneId', function (value) {
        return conversions.toClassReferenceId(value);
      })), Settings_1.Settings.schema.productCategoryId.valueOf(conversions.asObject(source, 'productCategoryId', function (value) {
        return conversions.toClassReferenceId(value);
      })), Settings_1.Settings.schema.productSensitivityId.valueOf(conversions.asObject(source, 'productSensitivityId', function (value) {
        return conversions.toClassReferenceId(value);
      })), Settings_1.Settings.schema.releaseId.valueOf(conversions.asObjectOpt(source, 'releaseId', function (value) {
        return conversions.toClassReferenceId(value);
      })), Settings_1.Settings.schema.competitorHistoryLength.valueOf(source.competitorHistoryLength), Settings_1.Settings.schema.competitorsPriorityId.valueOf(conversions.asObjectOpt(source, 'competitorsPriorityId', function (value) {
        return conversions.toClassReferenceId(value);
      })), conversions.asObjectOpt(source, 'constraintSettings', function (document) {
        return _this2.constraintSettingsConverter.toObject(document, conversions);
      }), conversions.asObjectOpt(source, 'optimizationGoalsSettings', function (document) {
        return _this2.optGoalsSettingsConverter.toObject(document, conversions);
      }), conversions.asObjectOpt(source, 'strategySettings', function (document) {
        return _this2.strategySettingsConverter.toObject(document, conversions);
      }));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this3 = this;

      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        title: source.title,
        priceZoneId: conversions.toDocumentReferenceId(source.priceZoneId),
        productCategoryId: conversions.toDocumentReferenceId(source.productCategoryId),
        productSensitivityId: conversions.toDocumentReferenceId(source.productSensitivityId),
        releaseId: conversions.toDocumentReferenceId(source.releaseId),
        competitorHistoryLength: source.competitorHistoryLength,
        competitorsPriorityId: conversions.toDocumentReferenceId(source.competitorsPriorityId)
      });
      Object.assign(result, {
        constraintSettings: conversions.asObjectOpt(source, 'constraintSettings', function (object) {
          return _this3.constraintSettingsConverter.toDocument(object, conversions);
        })
      });
      Object.assign(result, {
        optimizationGoalsSettings: conversions.asObjectOpt(source, 'optimizationGoalsSettings', function (object) {
          return _this3.optGoalsSettingsConverter.toDocument(object, conversions);
        })
      });
      Object.assign(result, {
        strategySettings: source.strategySettings != null ? this.strategySettingsConverter.toDocument(source.strategySettings, conversions) : null
      });
      return result;
    }
  }]);

  return SettingsConverterImpl;
}(SettingsConverter_1.SettingsConverter);

SettingsConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __param(1, typescript_ioc_1.Inject), __param(2, typescript_ioc_1.Inject), __metadata("design:paramtypes", [OptimizationGoalsSettingsConverter_1.OptimizationGoalsSettingsConverter, StrategySettingsConverter_1.StrategySettingsConverter, ConstraintSettingsConverter_1.ConstraintSettingsConverter])], SettingsConverterImpl);
exports.SettingsConverterImpl = SettingsConverterImpl;